export default __webpack_public_path__ + "static/slide2-245f755ddd405ed87793cb7315427d4f.jpg";